import React from 'react';
import Modal from './Modal';
import animation from "../assets/translation.gif";

const translations = {
    en: {
        translating: "Translating content...",
        toEnglish: "Translating to English",
        toDutch: "Translating to Dutch"
    },
    nl: {
        translating: "Inhoud vertalen...",
        toEnglish: "Vertalen naar Engels",
        toDutch: "Vertalen naar Nederlands"
    }
};

function TranslationModal({ isGeneratingPDF, isOpen, isDutch }) {
    const t = translations[isDutch ? 'nl' : 'en'];

    if (!isOpen) return null;
    
    return (
            <div className={`${isGeneratingPDF && "opacity-0"} rounded-full fixed bottom-6 left-0 right-0 flex flex-row items-center justify-center py-4 px-12 z-[105] bg-white w-fit  mx-auto border shadow-md gap-3`}>
            <img 
                        src={animation} 
                        alt="Loading..." 
                        className="w-16 h-16"
                    />
               <div>
               <p className="text-lg font-medium">
                    {t.translating}
                </p>
                <p className="text-sm text-gray-500">
                    {isDutch ? t.toDutch : t.toEnglish}
                </p>
               </div>
            </div>
    );
}

export default TranslationModal; 